
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/useAuth';

const PublicRoute = ({ element, path }) => {
    const { isAuthenticated } = useAuth();
    const location = useLocation();

    function containsAnyWord(string, wordArray) {
        if (!string || !wordArray || wordArray.length === 0) {
            return false;
        }
        for (let i = 0; i < wordArray.length; i++) {
            if (string && string.includes(wordArray[i])) {
                return true;
            }
        }
        return false;
    }

    // List of public paths
    const publicWords = [
        'vis2d', 'phd'
    ];

    if (containsAnyWord(path, publicWords)) {
        return element;
    } else {
        if (isAuthenticated) {
            if (window.location.href.includes('lessons')) {
                return <Navigate to="/ll/view" replace />;
            } else {
                return <Navigate to="/project-view" replace />;
            }
        } else {
            return element;
        }
    }
};

export default PublicRoute;